export default "__VITE_ASSET__DyHlb2hd__"